var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',[_c('b-form-input',{attrs:{"value":_vm.selection,"list":"my-list-id","autocomplete":"off","placeholder":"Start typing his/her UserName","type":"text"},on:{"input":_vm.change}}),_vm._v(" "),_c('datalist',{attrs:{"id":"my-list-id"}},_vm._l((_vm.suggestions),function(suggestion){return _c('option',[_vm._v(_vm._s(suggestion))])}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bae874c6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Autocomplete.vue
// module id = null
// module chunks = 